
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  folderListItemRename: {
    id: "ConfigurationEditFolder.heading",
    defaultMessage: "Edit Folder",
  },
  folderListItemDelete: {
    id: "FolderListItemDelete.text",
    defaultMessage: "Delete Folder",
  },
  folderListItemNestedRename: {
    id: "ConfigurationEditFolderNested.heading",
    defaultMessage: "Edit Construction Phase",
  },
  folderListItemNestedDelete: {
    id: "FolderListItemNestedDelete.text",
    defaultMessage: "Delete Construction Phase",
  },
});

export default MESSAGES;